<div class="overlay" *ngIf="isOpen">
  <div class="modal-container">

    <!-- HEADER -->
    <div class="modal-header">
      <p>{{ title }}</p>

      <button class="close-btn" (click)="fechar()">
        <img class="" src="assets/images/icons/close.svg" alt="fechar">
      </button>
    </div>

    <!-- BODY -->
    <div class="modal-body">
      <ng-content></ng-content>
    </div>

  </div>
</div>
